import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Toast as SaaghiToast } from '@takhfifan/saaghi';

import { messageActions } from 'Ducks';
import { GLOBALS } from 'Constants';

const Toast = ({ className, type, message, time, id, popToast }) => {
	const [isOpen, setIsOpen] = useState(true);

	const onCloseToast = () => {
		setIsOpen(false);
		popToast(id);
	};

	return (
		<SaaghiToast
			title={message}
			variant={type}
			show={isOpen}
			onClose={onCloseToast}
			timeout={time !== GLOBALS.TOAST_TIMEOUT.UNSET ? time : undefined}
			actionButton={'close'}
			hasTimeout={time !== GLOBALS.TOAST_TIMEOUT.UNSET}
			className={`${className} mt-8`}
		/>
	);
};

Toast.propTypes = {
	className: PropTypes.string,
	type: PropTypes.string,
	message: PropTypes.string.isRequired,
	time: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	id: PropTypes.number,
	popToast: PropTypes.func,
};

Toast.defaultProps = {
	className: '',
	type: 'info',
	time: GLOBALS.TOAST_TIMEOUT.DEFAULT,
};

const mapDispatchToProps = {
	popToast: messageActions.popToast,
};

export default connect(null, mapDispatchToProps)(Toast);
